<div
  *ngIf="showBackdrop"
  class="med-modal__backdrop"
></div>

<div class="med-modal__wrapper">
  <div
    class="med-modal__content"
    role="dialog"
    (clickOutside)="onClickOutside($event)"
    [ngStyle]="contentStyleList"
  >
    <button
      *ngIf="showCloseBtn"
      type="button"
      class="med-modal__close"
      (click)="onClose()"
    >
      <med-icon-x size="16px"></med-icon-x>
    </button>

    <ng-content></ng-content>
  </div>
</div>
